import { calculateRange, calculateStops, manualRange, type RangeInput } from "@auto-pools/core";
import type { RangeDirection, RangeEntryMode } from "../types";

export function preliminaryRange(
  reference: string,
  mode: RangeEntryMode,
  width: number,
  direction: RangeDirection,
  short: number,
  manualMin: string,
  manualMax: string,
) {
  if (mode === "manual") return { min: manualMin, max: manualMax };
  try {
    const result = calculateRange({
      referencePrice: reference,
      widthPercent: width as RangeInput["widthPercent"],
      mode: direction,
      shortPercent: direction === "balanced" ? undefined : (short as 3 | 5 | 10 | 15),
    });
    return { min: result.lowerPrice, max: result.upperPrice };
  } catch {
    return { min: "", max: "" };
  }
}

/** Trigger prices over the DISPLAYED bounds, from a per-side distance pair in the display frame. */
export function preliminaryStops(
  min: string,
  max: string,
  below: string,
  above: string,
  thresholdInverted = false,
) {
  try {
    manualRange(min, max);
  } catch {
    return {};
  }
  try {
    const result = calculateStops(min, max, {
      enabled: true,
      thresholdInverted,
      side: "both",
      lowerThresholdPercent: below,
      upperThresholdPercent: above,
    });
    return { lower: result.lowerTrigger, upper: result.upperTrigger };
  } catch {
    return {
      error:
        "Invalid stop geometry: inward stops must stay inside the LP range and the lower stop must stay below the upper stop.",
    };
  }
}
